import React from "react";
import { useTranslation } from "react-i18next";
import { CrimeReference } from "types";

type Props = {
  incident?: CrimeReference;
  setRefetch: React.Dispatch<React.SetStateAction<boolean>>;
};

const ScreeningTab: React.FC<Props> = ({ incident, setRefetch }) => {
  const { t } = useTranslation();

  return (
    <div className="space-y-6">
      {/* Director's message to the screening team */}
      {incident?.mesage_for_screeningteam && (
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
          <div className="border border-red-600 rounded-lg p-4 bg-gray-50">
            <p className="text-sm font-medium text-red-600 mb-2">
              {t("director_message")}
            </p>
            <p className="text-sm text-gray-700 mb-3">
              {incident?.mesage_for_screeningteam}
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default ScreeningTab;
